export default __webpack_public_path__ + "static/media/black-outline-heart.593fc7c2.svg";